<template>
  <div class="form-view">
    <el-form :model="ruleForm" ref="ruleForm" class="form-content" :label-width="formLabelWidth">
      <el-row class="form-row" :gutter="20" v-for="(item, index) in ruleForm.achievementDisplayForms" :key="index">
        <p class="form-sub-title">{{'成果' + (index + 1)}}
          <el-button class="btn" type="danger" icon="el-icon-delete" @click="dodel(index)" size="mini" circle ></el-button>
        </p>
        <el-col :span="12">
          <el-form-item label="所属类型" prop="achievementType">
            <el-input v-model="item.achievementType" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="成果名称" prop="achievementName">
            <el-input v-model="item.achievementName" class="input-with-select"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="相关描述" prop="remarks">
            <el-input v-model="item.remarks" type="textarea" placeholder="相关描述" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="照片" prop="urls">
            <ul class="uploadWarp">
              <li class="upli" v-for="(it, i) in item.attachmentForms" @click="showImg(index, i)" :key="i">
                <span class="delete el-icon-close" @click.stop="deleteImg(index, i)"></span>
                <el-image :src="it.url" class="avatar">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </li>
              <li class="upli" @click="curIndex = index">
                <el-upload action="" :show-file-list="false" :on-change="handleChange" ref="upload" accept="image/png, image/jpeg, image/jpg" :auto-upload="false">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </li>
            </ul>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="footer">
      <el-button type="warning" class="submit" @click="doAdd">新增</el-button>
      <el-button type="primary" class="submit" @click="submit('ruleForm')">提交</el-button>
    </div>
    <image-viewer :visible="visible" :data="urls" :initial-index="initIdx" @close="visible = false"></image-viewer>
  </div>
</template>

<script>
import ImageViewer from '@/components/ImageViewer'
import companyApi from '@/api/company'
import authApi from '@/api/auth'
export default {
  name: 'addqualification',
  components: {
    ImageViewer
  },
  props: ['rowId'],
  data () {
    return {
      formLabelWidth: '150px',
      ruleForm: {
        achievementDisplayForms: []
      },
      visible: false,
      urls: [],
      initIdx: 0,
      curIndex: 0
    }
  },
  methods: {
    dodel (index) {
      this.$confirm('是否确认删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.ruleForm.achievementDisplayForms.splice(index, 1)
      }).catch(() => { })
    },
    doAdd () {
      this.ruleForm.achievementDisplayForms.push({
        attachmentForms: [],
        achievementName: '',
        achievementType: '',
        remarks: ''
      })
    },
    showImg (index, i) {
      this.urls = this.ruleForm.achievementDisplayForms[index].attachmentForms.map(m => {
        return {
          url: m.url
        }
      })
      this.initIdx = i
      this.visible = true
    },
    deleteImg (index, idx) {
      this.$confirm('是否确认删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.ruleForm.achievementDisplayForms[index].attachmentForms.splice(idx, 1)
      }).catch(() => { })
    },
    handleChange (file, fileList) {
      console.log(this.curIndex)
      fileList = []
      var formData = new FormData()
      formData.append('file', file.raw)
      authApi.uploadFile(formData).then(res => {
        this.ruleForm.achievementDisplayForms[this.curIndex].attachmentForms.push({
          url: res.data
        })
      })
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.rowId = this.rowId
          companyApi.updateForMajor(this.ruleForm).then(res => {
            this.$message.success('修改成功!')
            this.$emit('action')
          })
        }
      })
    }
  },
  mounted () {
    if (this.rowId) {
      companyApi.queryDetailForMajorByRowId({
        rowId: this.rowId
      }).then(res => {
        this.ruleForm = res
        if (res.achievementDisplayForms.length === 0) {
          this.doAdd()
        }
      })
    } 
  }
}
</script>

<style scoped lang="less">
.form-view .form-content .form-row {
  border: 3px solid #eee;
  background: #f9f9f9;
  margin: 0 auto 15px !important;
  .form-sub-title{
    position: relative;
    .btn{position: absolute;
    right: 0;top: 0;}
  }
}
</style>